// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1973":"3b53517f","8444":"3b53517f"}[chunkId] + ".chunk.css");